import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { NgMaterialModule } from '../../shared/ng-material/ng-material.module';
import { BarChartRoutingModule } from './bar-chart-routing.module';
import { BarChartComponent } from './bar-chart.component';

@NgModule({
  declarations: [BarChartComponent],
  imports: [
    CommonModule,
    BarChartRoutingModule,
    NgMaterialModule,
  ],
})
export class BarChartModule { }
